import React, { useMemo, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import useStateRef from 'react-usestateref'
import useInterval from '@use-it/interval'

export default function InternetCheck({ channels, ...props}) {

  const getOnLineStatus = () => typeof navigator !== 'undefined' && typeof navigator.onLine === 'boolean' ? navigator.onLine : true;

  const [isGoogleReachable, setIsGoogleReachable] = useState(true)
  const [isOnline, setIsOnline] = React.useState(getOnLineStatus())

  const setOnline = () => setIsOnline(true);
  const setOffline = () => setIsOnline(false);

  useEffect(() => {
    window.addEventListener('online', setOnline);
    window.addEventListener('offline', setOffline);

    return () => {
      window.removeEventListener('online', setOnline);
      window.removeEventListener('offline', setOffline);
    }
  }, []);

  useInterval(() => {
    fetch('https://flave-assets.s3.eu-central-1.amazonaws.com/ping.html?' + new Date().getTime(), {
        method: 'HEAD',
        mode: 'no-cors',
        timeout: 4 * 1000,
      })
      .then(response => {
        console.debug(response)
        setIsGoogleReachable(true)
      }).catch(error => {
        console.error(error)
        setIsGoogleReachable(false)
    }).finally(() => {
    })
  }, (window.location.host == "localhost:3000" ? 120 : 10) * 1000)

  if(isOnline && isGoogleReachable) {
    return <></>
  }

  return <>
      <div className="network-status network-status-danger">
        <i className="fa fa-wifi-slash fa-fw"></i>{" "}
        No internet connection! Please check your network settings and try to disable your VPN or AdBlocker!
      </div>
      {" "}
    </>
}
